import { useMediaQuery, useTheme } from "@mui/material";
import { difference, isEqual } from "lodash";
import PropTypes from "prop-types";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";

const isArrayEqual = (arr1, arr2) => {
  return difference(arr1, arr2, isEqual)?.length === 0;
}

const DisplayLegends = forwardRef(function DisplayLegends({ isSepVessel, classes }, ref) {
  const [_data, _setData] = useState([]);

  useImperativeHandle(ref, () => ({
    setData (data) {
      if (!isArrayEqual(data, _data)) {
        _setData(data);
      }
    }
  }), []);

  return _data?.length > 0 && _data.map((t, i) => (
    <div key={i} className={classes.legendLineContainer}>
      <div className={classes.rectContainer}><div className={classes.rect} style={{ backgroundColor: t.color }} /></div>
      <div className={classes.legend}>{t.name}</div>
      <div className={classes.value}>{t.value !== null && t.value !== undefined ? t.value + (isSepVessel ? "kW" : "°C") : "--"}</div>
    </div>
  ));
});

export const DisplayTooltipData = ({ dataFetchStatus, isSepVessel, chart, classes }) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const [latestData, setLatestData] = useState([]);
  const cursor = chart.get("cursor");
  const legendRef = useRef(null);

  const setWithLatestData = () => {
    legendRef.current?.setData(latestData);
  }

  const pointerOutEvent = (e) => {
    const xAxis = e.target.get("xAxis");
    const positionX = e.target.getPrivate("positionX");
    const x = xAxis.toAxisPosition(positionX);

    const tmp = [];
    chart.series.each((series) => {
      const item = xAxis.getSeriesItem(series, x);
      const valueYField = series.get("valueYField");

      tmp.push({
        color: series.get("stroke").toString(),
        name: series.get("name").toString(),
        value: item.dataContext[valueYField]
      });
    });

    if (tmp.length > 0) {
      legendRef.current?.setData(tmp);
    }
  };

  if (!cursor.events.isDisposed()) {
    cursor.events.off("pointerover", pointerOutEvent);
    cursor.events.on("pointerover", pointerOutEvent);
  }

  useEffect(() => {
    setWithLatestData();
  }, [dataFetchStatus, latestData]);

  useEffect(() => {
    const tmp = [];
    chart.series.each((series) => {
      const latestData = series.data.values[series.data.length-1];
      const valueYField = series.get("valueYField");

      tmp.push({
        color: series.get("stroke")?.toString(),
        name: series.get("name")?.toString(),
        value: latestData[valueYField]
      });
    });

    setLatestData(isSm ? tmp.slice(0, 10) : tmp);
  }, [chart.series])

  return <DisplayLegends ref={legendRef} isSepVessel={isSepVessel} classes={classes} />;
}

DisplayLegends.propTypes = {
  isSepVessel: PropTypes.bool,
  classes: PropTypes.objectOf(PropTypes.string.isRequired).isRequired,
};

DisplayTooltipData.propTypes = {
  dataFetchStatus: PropTypes.object,
  isSepVessel: PropTypes.bool,
  chart: PropTypes.object,
  classes: PropTypes.objectOf(PropTypes.string.isRequired).isRequired,
};
